// Notification API helpers using backend endpoints
import { apiService } from '../services/apiService';

/**
 * Get all notifications
 * @param {number} limit - Number of notifications to fetch
 * @param {boolean} unreadOnly - Fetch only unread notifications
 */
export const getNotifications = async (limit = 40, unreadOnly = false) => {
  try {
    const response = await apiService.apiGet(
      `${import.meta.env.VITE_API_URL}/notifications?limit=${limit}&unread_only=${unreadOnly}`
    );
    return response;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};

/**
 * Get unread notification count
 */
export const getUnreadCount = async () => {
  try {
    const response = await apiService.apiGet(
      `${import.meta.env.VITE_API_URL}/notifications/unread-count`
    );
    return response.unread_count || 0;
  } catch (error) {
    console.error('Error fetching unread count:', error);
    return 0;
  }
};

/**
 * Mark a notification as read
 * @param {string} id - Notification ID
 */
export const markAsRead = async (id) => {
  try {
    const data = new FormData();
    const response = await apiService.apiPostForm(
      `${import.meta.env.VITE_API_URL}/notifications/${id}/mark-read`,
      data
    );
    return response;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    throw error;
  }
};

/**
 * Mark all notifications as read
 */
export const markAllAsRead = async () => {
  try {
    const data = new FormData();
    const response = await apiService.apiPostForm(
      `${import.meta.env.VITE_API_URL}/notifications/mark-all-read`,
      data
    );
    return response;
  } catch (error) {
    console.error('Error marking all as read:', error);
    throw error;
  }
};

/**
 * Delete a notification
 * @param {string} id - Notification ID
 */
export const deleteNotification = async (id) => {
  try {
    const response = await apiService.apiDelete(
      `${import.meta.env.VITE_API_URL}/notifications/${id}`
    );
    return response;
  } catch (error) {
    console.error('Error deleting notification:', error);
    throw error;
  }
};
